import { motion } from "framer-motion";
import { PROCESS_STEPS } from "../lib/data";

export default function Process() {
  return (
    <section
      id="proceso"
      data-testid="process-section"
      className="relative bg-[#0A0B0E] py-24 lg:py-36 border-t border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-20">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-8">
              <span className="w-8 h-px bg-[#D4AF37]" />
              <span className="text-[#D4AF37] text-xs uppercase tracking-[0.3em]">
                Así trabajamos
              </span>
            </div>
            <h2 className="font-display text-4xl lg:text-6xl leading-[1.05] tracking-tight text-white">
              Proceso simple,{" "}
              <span className="italic text-[#D4AF37]">resultado garantizado</span>.
            </h2>
          </div>
        </div>

        <div className="relative">
          {/* connection line */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {PROCESS_STEPS.map((step, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.15 }}
                data-testid={`process-step-${i}`}
                className="relative pl-2"
              >
                <div className="relative mb-8 flex items-center">
                  <span className="relative z-10 font-display text-7xl italic text-[#D4AF37] leading-none">
                    {step.n}
                  </span>
                  <span className="hidden lg:block ml-4 w-3 h-3 rounded-full border border-[#D4AF37] bg-[#0A0B0E]" />
                </div>
                <h3 className="font-display text-2xl text-white tracking-tight mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-white/55 font-light leading-relaxed pr-6">
                  {step.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
